import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column align-center" },
    [
      _c(
        VProgressCircular,
        {
          staticClass: "patient-profile-modal__progress-circular mb-4",
          attrs: {
            rotate: -90,
            size: 104,
            width: 8,
            value: _vm.trustPercent,
            color: _vm.canTrust ? "success" : "rating",
          },
        },
        [
          _c("div", { staticClass: "text-h5 text--text" }, [
            _vm._v("\n      " + _vm._s(_vm.trustPercent) + "%\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.canTrust
        ? _c(
            "span",
            {
              staticClass:
                "text-body-2 px-2 py-1 rounded-lg bg-success success--text",
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.t("Можно доверять", _setup.options)) +
                  "\n  "
              ),
            ]
          )
        : _c(
            "span",
            {
              staticClass:
                "text-body-2 px-2 py-1 rounded-lg bg-warning warning--text",
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _setup.t("Доверяйте с осторожностью", _setup.options)
                  ) +
                  "\n  "
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }